import React, { useState } from "react";
import apiClient from "../../ApiEndpoint/apiClient";
import "./chatbot.css";
import avatar from "../../assets/avatar.png";
import apiUrl from "../../ApiEndpoint/config";
import { useAuthContext } from "../../utils/AuthContext";

const ChatBot = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [inputText, setInputText] = useState("");
    const [messages, setMessages] = useState([
        { sender: "bot", text: "Hey! I'm Neo. How can I help you today?", complete: true },
    ]);
    const [isTyping, setIsTyping] = useState(false);
    const [selectedOption, setSelectedOption] = useState("0");
    const { user } = useAuthContext();

    // ✅ Send message handler
    const handleSend = async () => {
        if (!inputText.trim()) return;

        const userMessage = { text: inputText, sender: "user" };
        setMessages((prev) => [...prev, userMessage]);
        setInputText("");
        setIsTyping(true);

        const userEmail = user.email; // from Auth Context
        const currentSessionId = sessionStorage.getItem("currentSessionId");

        // ✅ Use params for query string
        const params = {
            query: inputText,
            user_email: userEmail,
            flag: parseInt(selectedOption, 10),
        };
        if (currentSessionId) params.session_id = currentSessionId;

        try {
            // ✅ POST with params (query string) instead of body
            const response = await apiClient.post(`${apiUrl}/askme`, null, { params });


            const botText = response.data.result || "No response received.";

            if (!currentSessionId && response?.data?.session_id) {
                sessionStorage.setItem("currentSessionId", response.data.session_id);
            }

            const botMessage = { text: botText, sender: "bot" };
            setMessages((prev) => [...prev, botMessage]);
            setIsTyping(false);
        } catch (error) {
            console.error("Error fetching response:", error);
            const errorResponse = {
                text: "Sorry, I couldn't get a response.",
                sender: "bot",
            };
            setMessages((prev) => [...prev, errorResponse]);
            setIsTyping(false);
        }
    };



    // ✅ Clear chat and reset session
    const handleClearChat = () => {
        // setMessages([
        //     { sender: "bot", text: "Hey! I'm Neo. How can I help you today?", complete: true },
        // ]);
        setMessages([]);
        sessionStorage.removeItem("currentSessionId");
    };

    return (
        <div className="chatbot-container">
            {!isOpen ? (
                <img
                    src={avatar}
                    alt="Chat"
                    className="chat-icon"
                    title="Neo Chat"
                    onClick={() => setIsOpen(true)}
                />
            ) : (
                <div className="chat-window">
                    <div className="chat-header">Welcome to Neo Chat</div>
                    <button className="close-btn" onClick={() => setIsOpen(false)}>×</button>

                    {/* ✅ Chat messages area */}
                    <div className="chat-messages">
                        {messages.map((msg, idx) => (
                            <div key={idx} className={`chat-message ${msg.sender}`}>
                                {msg.text}
                            </div>
                        ))}

                        {isTyping && (
                            <div className="typing-indicator">
                                <img
                                    src={avatar}
                                    alt="Chat"
                                    style={{ width: "2rem", height: "2rem", cursor: "pointer" }}
                                />
                                Neo is thinking
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                            </div>
                        )}
                    </div>

                    {/* ✅ Input + Controls */}
                    <div className="chat-controls">
                        <div className="chat-input">
                            <input
                                type="text"
                                value={inputText}
                                onChange={(e) => setInputText(e.target.value)}
                                placeholder="Type your message..."
                                onKeyDown={(e) => e.key === "Enter" && handleSend()}
                            />
                            <button onClick={handleSend}>Send</button>
                        </div>

                        <div
                            className="chat-options"
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginTop: "8px",
                            }}
                        >
                            <select
                                className="form-select"
                                style={{
                                    width: "8rem",
                                    height: "32px",
                                    borderColor: "#0d6efd",
                                    fontSize: "12px",
                                    color: "#666f86",
                                    marginRight: "10px",
                                }}
                                value={selectedOption}
                                onChange={(e) => setSelectedOption(e.target.value)}
                            >
                                <option value="0">All</option>
                                <option value="1">Web Search</option>
                                <option value="2">EPA </option>
                                <option value="3">Salesforce</option>
                                <option value="4">IIR</option>
                                <option value="5">Building </option>
                                <option value="6">SEC </option>
                                <option value="7">Microgrid </option>
                                <option value="8"> CHP </option>
                            </select>

                            <button className="clear-btn" onClick={handleClearChat}>
                                Clear Chat
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChatBot;
